import styled from "styled-components";

export const Caixa = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #DDE6F0;
  background: #F4F8FC;
  font-size: 12px;
  line-height: 1.45;
  color: #3D4A5C;

  strong{ font-size: 12px; color: #26466D; }
  p{ margin: 0; }

  .avaliacao{
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px dashed #C6D3E3;
  }
  .escolhida{ font-weight: 700; color: #111; }
  .bom{ color: #1f7a33; font-weight: 600; }
  .aviso{ color: #8A5A00; font-weight: 600; }
`;
